import type { ListingsAPIFacetSpec, ListingsAPIInterval } from '../types/ListingsAPIFacetSpec';

export class ListingsRequestFacetIntervalBuilder {
  private readonly data: ListingsAPIInterval = {};

  min(n: number, exclusive: boolean = false): this {
    if (exclusive) {
      this.data.exclusiveMinimum = n;
    } else {
      this.data.minimum = n;
    }
    return this;
  }

  max(n: number, exclusive: boolean = false): this {
    if (exclusive) {
      this.data.exclusiveMaximum = n;
    } else {
      this.data.maximum = n;
    }
    return this;
  }

  build(): ListingsAPIInterval {
    return { ...this.data };
  }
}

export class ListingsRequestFacetBuilder {
  private readonly entry: ListingsAPIFacetSpec;

  constructor(key: string) {
    if (!key) {
      throw new Error('Key must be specified for the facet');
    }

    this.entry = {
      facetKey: {
        key,
      },
    };
  }

  orderBy(value: string): this {
    this.entry.facetKey.orderBy = value;
    return this;
  }

  intervals(intervals: ListingsAPIInterval[]): this {
    if (this.entry.facetKey.intervals && this.entry.facetKey.intervals.length) {
      throw new Error('intervals have already been added to this facet');
    }
    this.entry.facetKey.intervals = intervals;
    return this;
  }

  excludedFilterKeys(...keys: string[]): this {
    this.entry.excludedFilterKeys = keys;
    return this;
  }

  enableDynamicPosition(value = true): this {
    this.entry.enableDynamicPosition = value;
    return this;
  }

  build(): ListingsAPIFacetSpec {
    return { ...this.entry };
  }
}
